module.exports = __webpack_public_path__ + "Astar600.png";